import api from '../../apiConfig/apiConfig'
import { Get, Post, Put, Delete } from '../base/baseAjax'
let taskList = param => {
  return Post({
    url: api.remark.taskList,
    bodyParam: param
  })
}

let getRemoveTask = param => {
  return Delete({
    url: api.remark.getRemoveTask,
    PathParam: param
  })
}

let addTask = param => {
  return Post({
    url: api.remark.addTask,
    bodyParam: param
  })
}

let logList = param => {
  return Post({
    url: api.remark.logList,
    bodyParam: param
  })
}
export default {
  taskList: taskList,
  getRemoveTask: getRemoveTask,
  addTask: addTask,
  logList: logList
}
